import { APIData, appFetch } from ".";

type Image = {
  id: number;
  image: string;
  created_at: string;
};
export interface Project {
  id: number;
  name: string;
  description: string;
  is_active: number;
  created_at: string;
  images: Image[];
  categories_description: string;
}

export const projectsAPI = {
  fetchPage(page: number) {
    return appFetch<APIData<Project[]>>("/projects?page=" + page);
  },
};
